import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import { State } from './types'

const initialState: State = {
  isSignInModalOpen: false,
  isSignUpModalOpen: false,
  isPostModalOpen: false,
  isProfileEditModalOpen: false,
  isCreateTeamModalOpen: false,
  isCreateCommunityModalOpen: false,
  isCreateGameModalOpen: false,
  isCreateTournamentModalOpen: false,
  isLoaderForTournament: false,
  isSuccessTournamentModalOpen: false,
  isEndTournamentModalOpen: false,
  tournamentCommunityContext: null,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setIsSignInModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isSignInModalOpen = action.payload
    },
    setIsSignUpModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isSignUpModalOpen = action.payload
    },
    setIsPostModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isPostModalOpen = action.payload
    },
    setIsProfileEditModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isProfileEditModalOpen = action.payload
    },
    setIsCreateTeamModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateTeamModalOpen = action.payload
    },
    setIsCreateCommunityModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateCommunityModalOpen = action.payload
    },
    setIsCreateGameModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateGameModalOpen = action.payload
    },
    setIsCreateTournamentModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateTournamentModalOpen = action.payload
    },

    setIsLoaderForTournament: (state, action: PayloadAction<boolean>) => {
      state.isLoaderForTournament = action.payload
    },
    setIsSuccessTournamentModalOpen: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.isSuccessTournamentModalOpen = action.payload
    },
    setIsEndTournamentModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isEndTournamentModalOpen = action.payload
    },
    setTournamentCommunityContext: (
      state,
      action: PayloadAction<{ communityId: string; communityName: string } | null>,
    ) => {
      state.tournamentCommunityContext = action.payload
    },
  },
  extraReducers: () => {},
})

export const { reducer, actions } = appSlice

export default appSlice
